import png1 from "./1.jpg";
import png2 from "./2.jpg";
import png3 from "./3.jpg";
import png4 from "./4.jpg";
import png5 from "./5.jpg";
export const yzyh = [
  {
    name: "查找流水",
    msgList: [
      { msg: "登录邮政银行APP->顶部搜索【账户明细打印】" },
      { imgs: [png1, png2] },
    ],
  },
  {
    name: "发送账单",
    msgList: [
      { msg: "选择【近1年】，填入专属邮箱【提交】" },
      { imgs: [png3, png4, png5] },
    ],
  },
  {
    name: "注意事项",
    msgList: [
      {
        msg: "打开【显示对方户名和账号】【显示完整户名和账号】【显示收入及支出汇总金额】",
      },
    ],
  },
];
